/** Catalog context and actions exposed to the Assistant.
 *
 * The browser remains the authority: it sends only rows already returned for
 * the signed-in person and opens an exact id through the Catalog's normal path.
 */

import type { AssistantCatalogContext } from '../../api/types.ts';
import { catalogAvailable } from '../../state/store.ts';
import {
  catalogCharts,
  catalogLoaded,
  loadCatalog,
} from '../catalog/catalog-state.ts';
import { chartSummary } from '../catalog/chart-summary.ts';

const MAX_CATALOG_CHARTS = 300;

export async function buildCatalogContext(): Promise<AssistantCatalogContext | null> {
  if (!catalogAvailable.value) return null;
  if (!catalogLoaded.value) await loadCatalog();
  if (!catalogLoaded.value) return null;
  const all = catalogCharts.value;
  return {
    charts: all.slice(0, MAX_CATALOG_CHARTS).map((chart) => ({
      id: chart.id,
      title: chart.title,
      plot_type: chart.plot_type,
      summary: chartSummary(chart),
      description: chart.description?.slice(0, 500) ?? null,
      owner: chart.owner.display_name,
      tags: chart.tags.slice(0, 20),
      is_owner: chart.is_owner,
      shared_directly: chart.shared_directly,
      is_public: chart.is_public,
    })),
    total: all.length,
    truncated: all.length > MAX_CATALOG_CHARTS,
  };
}
